import { Fab } from "@mui/material";
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';


const ChatBotLauncher = ({ onClick }) => {
    return (
        <Fab
            onClick={onClick}
            sx={{
                position: "fixed",
                bottom: 15,
                right: 20,
                width: 56,
                height: 56,
                backgroundColor: "neutral.teal",
                color: "#fff",
                boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                "&:hover": {
                    backgroundColor: "neutral.teal",
                },
                zIndex: 1300, // drawer se niche na ho
            }}
        >
            <ForumOutlinedIcon />
        </Fab>
    );
};

export default ChatBotLauncher;
